import React from 'react';
import { CountdownTimer } from './CountdownTimer';
export function FinalCTASection() {
  return <section aria-label="Llamada final a la acción" className="bg-brand-dark text-white py-24 px-4 relative border-t border-brand-border" data-id="element-85">
      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-86">
        <div className="flex items-center justify-center gap-2 text-brand-accent font-badge font-bold tracking-widest text-sm uppercase mb-6" data-id="element-87">
          <span className="text-xl" aria-hidden="true" data-id="element-88">
            🔬
          </span>{' '}
          PROFEPACK
        </div>
        <p className="text-xl md:text-2xl text-white/70 mb-4 italic" data-id="element-89">
          El próximo domingo podés seguir buscando actividades en Google.
        </p>
        <p className="text-2xl md:text-3xl font-heading font-bold text-brand-accent mb-16" data-id="element-90">
          O podés tener todo resuelto desde hoy.
        </p>
        <div className="mb-12" data-id="element-91">
          <CountdownTimer data-id="element-92" />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-16 max-w-3xl mx-auto" data-id="element-93">
          <div className="bg-brand-card p-5 rounded-2xl border border-brand-border flex flex-col items-center justify-between" data-id="element-94">
            <div className="font-bold text-white/60 mb-2 text-sm" data-id="element-95">
              ⚡ FÍSICA
            </div>
            <div className="text-2xl font-heading font-bold text-white mb-4" data-id="element-96">
              $19.990 ARS
            </div>
            <button onClick={() => window.open('https://www.profepack.com/cart/48097185071360:1', '_blank')} className="w-full bg-brand-accent/10 border border-brand-accent/30 hover:bg-brand-accent/20 text-brand-accent py-3 rounded-2xl text-sm font-black transition-colors" data-id="element-97">
              → QUIERO FÍSICA
            </button>
          </div>
          <div className="bg-brand-card p-5 rounded-2xl border-2 border-brand-accent flex flex-col items-center justify-between transform md:scale-105 z-10" data-id="element-98">
            <div className="font-bold text-brand-accent mb-2 text-sm" data-id="element-99">
              🏆 PACK COMPLETO ⭐
            </div>
            <div className="text-3xl font-heading font-bold text-brand-accent mb-4" data-id="element-100">
              $29.990 ARS
            </div>
            <button onClick={() => window.open('https://www.profepack.com/cart/48108607242496:1', '_blank')} className="w-full bg-brand-accent hover:bg-brand-accent-dim text-brand-dark py-3 rounded-2xl text-sm font-black transition-colors" data-id="element-101">
              → QUIERO MI MEGAPACK
            </button>
          </div>
          <div className="bg-brand-card p-5 rounded-2xl border border-brand-border flex flex-col items-center justify-between" data-id="element-102">
            <div className="font-bold text-white/60 mb-2 text-sm" data-id="element-103">
              🧪 QUÍMICA
            </div>
            <div className="text-2xl font-heading font-bold text-white mb-4" data-id="element-104">
              $19.990 ARS
            </div>
            <button onClick={() => window.open('https://www.profepack.com/cart/48097186545920:1', '_blank')} className="w-full bg-brand-accent/10 border border-brand-accent/30 hover:bg-brand-accent/20 text-brand-accent py-3 rounded-2xl text-sm font-black transition-colors" data-id="element-105">
              → QUIERO QUÍMICA
            </button>
          </div>
        </div>
        <div className="flex flex-wrap justify-center gap-6 md:gap-10 text-white/70 font-medium mb-16 text-sm" data-id="element-106">
          <span data-id="element-107">🔒 Pago 100% seguro</span>
          <span data-id="element-108">⚡ Acceso en 5 minutos</span>
          <span data-id="element-109">🛡️ Garantía 7 días sin preguntas</span>
          <span data-id="element-110">💳 Mercado Pago | Tarjeta | Transferencia</span>
        </div>
        <div className="border-t border-brand-border pt-12 max-w-2xl mx-auto" data-id="element-111">
          <div className="flex items-center justify-center gap-2 text-brand-accent font-badge font-bold tracking-widest text-xs uppercase mb-4" data-id="element-112">
            <span aria-hidden="true" data-id="element-113">🔬</span> PROFEPACK
          </div>
          <p className="text-white/60 italic mb-2 text-sm" data-id="element-114">
            El sistema de planificación científica N°1 para docentes de Física y
            Química de secundaria en Argentina.
          </p>
          <p className="text-white/60 italic text-sm" data-id="element-115">
            Porque enseñar ciencias no debería costarte todos los domingos del
            año.
          </p>
        </div>
      </div>
    </section>;
}